import { t } from "i18next";
import React from "react";

import {
  AppStore,
  GooglePlay,
  Linkedin,
  SalutoLogoWhite,
} from "../commons/Icons/Icons";

import useTranslation from "../hooks/useTranslation";

interface ViewProps {
  pathName: string;
}

function FootView(props: ViewProps) {
  const { t } = useTranslation(props.pathName);

  return (
    <>
      <div
        style={{ backgroundColor: "#464C63" }}
        className="sm:h-60 h-96 w-full sm:flex-row flex-col sm:gap-y-0 gap-y-5 flex mt-0 pt-0"
      >
        <div className="w-4/5 mx-auto flex sm:flex-row flex-col sm:gap-y-0 gap-y-5">
          <div className="w-full sm:w-1/4 flex items-center justify-center">
          <div className="sm:mt-0 mt-5  w-3/5 ">
            <SalutoLogoWhite></SalutoLogoWhite>
          </div>
        </div>
          <div className="w-full  sm:w-1/2 m-auto flex-col h-1/2 items-center justify-center  flex">
          <div style={{ color: "white" }} className="font-bold text-lg">
            <p className="text-center ">{t("info@saluto.ai")}</p>
            <p className="text-center">
              {t("Epicenter - Malmskillnadsgatan 44A, 111 57 Stockholm")}
            </p>
            <div className="flex place-content-center">
              <div className="w-8">
                <Linkedin />
              </div>
              <p> linkedin.com/company/salutoai</p>
            </div>
          </div>
          <div className="w-3/4  m-auto justify-center gap-x-10 flex">
            <a
              href="/saluto_policies"
                className="text-white block text-center"
                style={{ color: "white" }}
              >
                {t("Copyright")}
              </a>
              <a
                href="/saluto_user_policies"
              className="text-white block text-center"
                style={{ color: "white" }}
            >
                {t("Terms & Conditions")}
              </a>
              <a
              href="/saluto_policies"
              className="text-white block text-center"
                style={{ color: "white" }}
            >
                {t("Privacy Policy")}
              </a>
              { }
          </div>
        </div>
        <div className=" gap-x-4  justify-center flex-col gap-y-4 flex  items-center  sm:w-1/4">
          <p className="text-center sm:text-left" style={{ color: "white" }}>
            {t("DOWNLOAD OUR APP")}
          </p>
          <div className="flex gap-x-4 mx-5 sm:mr-10 mb-5  justify-center">
            <a
              rel="noopener norefferer"
              href="https://play.google.com/store/apps/details?id=ai.saluto.saluto"
              target="_blank"
            >
              <GooglePlay />
            </a>
            <div>
              <a
                rel="noopener norefferer"
                href="https://apps.apple.com/se/app/saluto/id1624455377?platform=iphone"
                target="_blank"
              >
                <AppStore />
              </a>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default FootView;
